import { useState } from 'react';
import type { OrderDetail } from '@wave/shared';
import { Modal } from '../Modal';
import { btnPrimary, btnSecondary, textareaCls } from '../../lib/styles';
import { buildClientMessage } from '../../lib/clientMessage';

interface Props {
  order: OrderDetail;
  onClose: () => void;
}

/** Готовый текст для отправки клиенту в чат: принимаем / курс / к получению / № заявки. */
export function ClientMessageModal({ order, onClose }: Props) {
  const [text, setText] = useState(() => buildClientMessage(order));
  const [copied, setCopied] = useState(false);

  async function copy() {
    try {
      if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(text);
      } else {
        // Fallback для небезопасного контекста (http): скрытая textarea + execCommand.
        const ta = document.createElement('textarea');
        ta.value = text;
        ta.style.position = 'fixed';
        ta.style.opacity = '0';
        document.body.appendChild(ta);
        ta.select();
        document.execCommand('copy');
        document.body.removeChild(ta);
      }
      setCopied(true);
      window.setTimeout(() => setCopied(false), 2000);
    } catch {
      // Копирование недоступно — текст остаётся видимым и выделяемым в поле,
      // менеджер копирует вручную (Ctrl+C).
      setCopied(false);
    }
  }

  return (
    <Modal title={`Сообщение клиенту · ${order.id}`} onClose={onClose}>
      <div className="space-y-4">
        <p className="text-sm text-text2">
          Готовый текст для отправки клиенту в чат. Можно отредактировать перед копированием.
        </p>
        <textarea
          value={text}
          onChange={(e) => setText(e.target.value)}
          rows={7}
          autoFocus
          className={`${textareaCls} font-mono`}
        />
        <div className="flex items-center justify-end gap-2">
          <button type="button" onClick={onClose} className={btnSecondary}>
            Закрыть
          </button>
          <button type="button" onClick={copy} className={btnPrimary}>
            {copied ? 'Скопировано ✓' : 'Скопировать'}
          </button>
        </div>
      </div>
    </Modal>
  );
}
